export default "__VITE_ASSET__BPLoa9uf__"